import { IRowElement } from '@doseme/cohesive-ui'

const paginate = (
  data: IRowElement[],
  pageNav: {
    currentPage: number,
    itemsPerPage: number
  }
): IRowElement[] => {
  const { currentPage, itemsPerPage } = pageNav
  return data.slice(
    (currentPage - 1) * itemsPerPage,
    itemsPerPage * currentPage
  )
}

export {
  paginate
}
